$rise_demo $mol_app_demo
	menu_title \$rise
	sources_uri \https://github.com/stan-donarise/mam_rise
	plugins /
		<= Devtools $rise_devtools_plugin
